import {Exist} from "components/Exist";
import {LoginGigyaModal, RegistrationGigyaModal, RegistrationModal} from "components/Modals";
import {toggleLoginOpen, toggleRegistrationOpen} from "modules/actions";
import {
	getIsLoginOpen,
	getIsRegistrationOpen,
	getUser,
	isAdditionalDataRequired,
} from "modules/selectors";
import React, {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

export const AuthFlow: React.FC = () => {
	const dispatch = useDispatch();
	const isLoginVisible = useSelector(getIsLoginOpen)
	const isRegistrationVisible = useSelector(getIsRegistrationOpen)
	const isRegistrationRequired = useSelector(isAdditionalDataRequired);
	const user = useSelector(getUser);

	const closeLogin = useCallback(() => {
		dispatch(toggleLoginOpen(false));
	}, [dispatch])

	const closeRegistration = useCallback(() => {
		dispatch(toggleRegistrationOpen(false));
	}, [dispatch])

	useEffect(() => {
		if (isRegistrationRequired) {
			dispatch(toggleLoginOpen(false));
			dispatch(toggleRegistrationOpen(false));
		}
	}, [dispatch, isRegistrationRequired]);

	useEffect(() => {
		if (user) {
			closeLogin();
			closeRegistration();
		}
	}, [user, closeLogin, closeRegistration]);

    return (
        <React.Fragment>
			<Exist when={isLoginVisible}>
				<LoginGigyaModal onClose={closeLogin} />
			</Exist>
			<Exist when={isRegistrationVisible}>
				<RegistrationGigyaModal onClose={closeRegistration} />
			</Exist>
			<Exist when={isRegistrationRequired}>
				<RegistrationModal />
			</Exist>
        </React.Fragment>
    );
};
